export default [
    'Purchase',
    'Refi',
    'Construction'
];